//Local
// export const API_BASE_URL = "http://localhost:57646/";

//Development http://streamauthoringstaging.innostratsolutions.in/
// export const API_BASE_URL = "http://asmlapi.innostratsolutions.in/";

//Staging https://staging.streamauthoring.com/
// export const API_BASE_URL = "https://staging.streamauthoring.com:8181/";

// Production    https://streamauthoring.com/
export const API_BASE_URL = "https://streamauthoring.com:8080/";

export const API_URL = `${API_BASE_URL}/api`;
export const API_IMAGES_URL = `${API_BASE_URL}/images`;
//export const PASS_PERCENT = 50;
export const WorkflowId = 2;
export const LearningId = 3;
//export const ALLOWED_QUESTIONS = 20;
export const ASSIGNMENT_IMAGE_PATH = API_BASE_URL + "images/assignment/";
export const SESSION_TIMEOUT =
  API_BASE_URL.indexOf("asmldevapi") >= 0 || API_BASE_URL.indexOf("localhost") >= 0 ? 20 * 60 * 1000 : 20 * 60 * 1000;

export const toolbarConfig = [
  {
    name: "clipboard",
    groups: ["clipboard", "undo"],
    items: ["Cut", "Copy", "Paste", "PasteText", "PasteFromWord", "-", "Undo", "Redo"],
  },
  {
    name: "editing",
    groups: ["spellchecker"],
    items: ["Scayt"],
  },
  {
    name: "basicstyles",
    groups: ["basicstyles", "cleanup"],
    items: ["Bold", "Italic", "Underline", "Strike", "Subscript", "Superscript", "-", "CopyFormatting", "RemoveFormat"],
  },
  {
    name: "paragraph",
    groups: ["list", "indent", "blocks", "align", "bidi"],
    items: ["NumberedList", "BulletedList", "-", "Outdent", "Indent", "-", "Blockquote"],
  },
  { name: "links", items: ["Link", "Unlink"] },
  {
    name: "insert",
    items: ["Table", "HorizontalRule", "SpecialChar"],
  },
  { name: "tools", items: ["Maximize"] },
];



// WEBPACK FOOTER //
// ./src/constants.js